import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import {
  AssessmentTL2RelationshipStoreModel,
  AssessmentTL2RelationshipUIModel,
} from './assessment-tl2-relationship.model';
import { AssessmentTL2RelationshipState, AssessmentTL2RelationshipStore } from './assessment-tl2-relationship.store';

@Injectable({ providedIn: 'root' })
export class AssessmentTL2RelationshipQuery extends QueryEntity<
  AssessmentTL2RelationshipState,
  AssessmentTL2RelationshipStoreModel,
  AssessmentTL2RelationshipUIModel
> {
  constructor(protected override store: AssessmentTL2RelationshipStore) {
    super(store);
  }
}
